import React from "react"
import { graphql, Link } from "gatsby"
import Blognavbar from "../Components/blognavbar"
import BlogFooter from "../Components/blogfooter"
import { Row, Col, Container, Card } from "react-bootstrap"
import Img from "gatsby-image"
import "../Styles/singlepost.scss"

import { AiOutlineShareAlt, AiFillHeart } from "react-icons/ai"
import { GrView } from "react-icons/gr"
import {BsHeart } from "react-icons/bs"
import { MdDateRange } from "react-icons/md"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "bootstrap/dist/css/bootstrap.min.css"
import { library } from "../../node_modules/@fortawesome/fontawesome-svg-core"
import { fab } from "../../node_modules/@fortawesome/free-brands-svg-icons"
import {
  faHashtag,
  faEnvelope,
  faPhone,
  faCalendar,
  faHeart,
  faEye,
  faShare,
} from "../../node_modules/@fortawesome/free-solid-svg-icons"
library.add(fab, faHashtag, faEnvelope, faPhone , faCalendar, faHeart, faEye , faShare)



const Singlepost = ({ data }) => {
  const post = data.markdownRemark.frontmatter
  return (
    <div className="single-post">
      <Blognavbar />
      <div className="float-icon-post">
                  <ul>
                    <li>
                      <AiOutlineShareAlt />
                    </li>
                    <li>
                      <AiFillHeart />
                    </li>
                  </ul>

                </div>
      <Container>
        <Row>
          <Col xl="12">
            <Card className="single-post-card">
              <Card.Body>
          
                


                <div className="single-post-image-div">
                  <Img
                    className="single-post-image"
                    fluid={post.image.childImageSharp.fluid}
                  />
                   
                </div>
                <Card.Title>
                  <Link className="single-post-title" to={data.markdownRemark.fields.slug}>
                    {post.title}
                  </Link>
                </Card.Title>
                <div className="single-post-divider" />

                <Card.Subtitle>
                  <p className="single-post-subtitle">{post.subtitle}</p>
                </Card.Subtitle>

                <div
                  className="single-post-txt"
                  dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}
                />
              </Card.Body>

              <div className="single-post-downbar">
                <ul>
                  <li className="single-post-downbar-item">
                    <ul>
                      <li>
                        <span> 
                          <small style={{marginLeft:"3px"}}>
                          view:
                          </small>
                          <small>
                            &nbsp;120
                          </small>
                          
                         
                        </span>
                      </li>
                      <li>
<GrView/>
                      </li>
                    </ul>
                  </li>
                  <li className="single-post-downbar-item">
                  <ul>
                      <li >
                        <span> 
                          <small style={{marginLeft:"3px"}}>
                          like:
                          </small>
                          <small>
                            &nbsp;52
                          </small>
                          
                         
                        </span>
                      </li>
                      <li>
<BsHeart/>
                      </li>
                    </ul>
                  </li>
                  <li className="single-post-downbar-item">
                  <ul>
                      <li>
                        <span> 
                          <small style={{marginLeft:"3px"}}>
                          like:
                          </small>
                          <small>
                            &nbsp;52
                          </small>
                          
                         
                        </span>
                      </li>
                      <li>
<MdDateRange/>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>

            </Card>
          </Col>

          <Col xl="12">
            <Card className="other-news">
              <p className="other-news-bigtitle">other news</p>
            </Card>
          </Col>
        </Row>
      </Container>
      <BlogFooter />
    </div>
  )
}

export const postQuery = graphql`
  query blogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        cat
        title
        subtitle
        date
        path
        image {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      fields{
        slug
      }
      excerpt
    }
  }
`


export default Singlepost

